<template>
  <header class="header">
    <h1
      v-if="currentCommitteeName"
      class="header__title"
    >
      {{ currentCommitteeName }}
    </h1>
    <v-hamburger class="header__trigger" />
    <router-link to="/dashboard">
      <v-logo
        class="header__logo"
        is-light
        is-landscape
      />
    </router-link>
    <div class="header__menus">
      <v-dropdown
        class="header__dropdown"
        is-light
        has-gradient
        is-right
        :count="Object.keys(latestNotifications).length"
      >
        <v-icon
          type="bell-o"
          size="lg"
          is-fixed
        />
        <template #dropdown-menu>
          <template v-if="Object.keys(latestNotifications).length > 0">
            <v-notification
              v-for="(notification,index) in topNotification"
              :key="index"
              :text="notification.title"
              :link="notification.data.data.url"
              @click="resolveNotification(notification)"
            />
          </template>
          <template v-else>
            No new notifications.
          </template>
          <v-dropdown-item
            class="text--right"
            to="/notifications"
          >
            View all
          </v-dropdown-item>
        </template>
      </v-dropdown>
      <v-dropdown
        class="header__dropdown header__dropdown--menu"
        is-light
        has-chevron
        is-right
      >
        <v-avatar
          :name="$store.getters.getUsername"
          :meta="currentRoleFull"
        />
        <template #dropdown-menu>
          <v-dropdown-item to="/profile">
            View Profile
          </v-dropdown-item>
          <v-dropdown-item to="/change-password">
            Change Password
          </v-dropdown-item>
          <v-dropdown-item to="/profile2fa">
            2 Step Verification
          </v-dropdown-item>
          <hr>
          <template v-if="roles.length > 1">
            <h5>Switch view to</h5>
            <v-dropdown-item
              v-for="role in roles"
              :key="role"
              :value="role"
              :is-active="checkCurrentRole(role)"
              @click="performAction('SWITCH_ROLE', role)"
            >
              {{ checkRoleFullName(role) }}
            </v-dropdown-item>
            <hr>
          </template>
          <template v-if="checkCurrentRole(constants.NATA_ROLE_CM) && committees.length > 0">
            <h5>Switch Committees</h5>
            <v-dropdown-item
              v-for="com in committees"
              :key="com.id"
              :value="com.id"
              class="dropdown-item"
              :is-active="checkCurrentCommittee(com.id)"
              @click="performAction('SWITCH_COMMITTEE', com)"
            >
              {{ com.name }}
            </v-dropdown-item>
            <hr>
          </template>
          <v-button
            class="mb-0"
            is-block
            size="lg"
            @click="logout()"
          >
            Log Out
            <v-icon type="logout" />
          </v-button>
        </template>
      </v-dropdown>
    </div>
    <v-modal
      v-show="showAdminNotifyModal"
      ref="appmodal"
      @close="closeModal"
    >
      <template #header>
        {{ adminNotifyTitle }}
      </template>
      <template>
        {{ adminNotifyBody }}
      </template>
      <template #footer>
        <v-button-group is-inline>
          <v-button
            v-if="userAction.requireConfirmation"
            size="lg"
            has-min-width
            @click="confirmAction"
          >
            Ok
          </v-button>
          <v-button
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ userAction.requireConfirmation ? 'Cancel' : 'Close' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </header>
</template>

<script>
  import switchRole from "@/common/switchRole";
  import switchCommittee from "@/common/switchCommittee";
  import Icon from "@/atoms/Icon";
  import Logo from "@/atoms/Logo";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Avatar from "@/atoms/Avatar";
  import Hamburger from "@/atoms/Hamburger";
  import Notification from "@/atoms/Notification";
  import Dropdown from "@/molecules/Dropdown";
  import DropdownItem from "@/atoms/DropdownItem";
  import constants from "@/common/constants";
  import {mapState} from "vuex";
  import { LOGOUT } from "@/store/actions.type";
  import router from '@/router';
  import {notificationResolver, setNotificationModalDialog, getNotifications} from "@/common/notificationUtils"; 
  import {getRoleName} from "@/common/tableFunctions"; 
  import Modal from "@/atoms/Modal";

  export default {
    components: {
      "v-icon": Icon,
      "v-logo": Logo,
      "v-button": Button,
      "v-hamburger": Hamburger,
      "v-notification": Notification,
      "v-dropdown": Dropdown,
      "v-dropdown-item": DropdownItem,
      "v-avatar": Avatar,
      "v-modal": Modal,
      "v-button-group": ButtonGroup
    },
    data() {
      return {
        showAdminNotifyModal: false,
        adminNotifyTitle: null,
        adminNotifyBody: null,
        userAction: {
          actionKey: '',
          actionPayload: null,
          requireConfirmation: false,
          isConfirmed: false
        }
      }
    },
    computed: {
      roles() {
        return (localStorage.getItem('ROLE') || '').split(',').filter(Boolean);
      },
      currentRole() {
        return localStorage.getItem(constants.CURRENT_ROLE)
      },
      currentRoleFull() {
        const matchingRole = constants.USER_ROLES.find(r => r.name === this.currentRole);
        return matchingRole ? matchingRole.fullName : this.currentRole;
      },
      topNotification() {
        let notify = this.latestNotifications;
        return Object.keys(this.latestNotifications).slice(0, 3).reduce((result, key) => {
          result[key] = notify[key];
          return result;
        }, {});
      },
      currentCommitteeName() {
        let name;
        if (this.committees.length && this.currentRole === constants.NATA_ROLE_CM) {
          name = this.committees.find(c => c.id === this.selectedCommittee).name
        }
        return name;
      },
      ...mapState({
        committees: state => state.auth.committees,
        selectedCommittee: state => state.auth.selectedCommittee,
        latestNotifications: state => state.notification.latestNotifications,
        length: state => state.notification.length,
      }),
    },
    mounted() {
      getNotifications();
      setNotificationModalDialog(this);
    },
    created () {
      this.constants = constants;
    },
    methods: {
      resolveNotification(notification) {
        notificationResolver(notification);
      },
      performAction(action, payload) {
        if('SWITCH_COMMITTEE' === action) {
          this.updateUserAction(action, payload, true, false);

          this.showAdminNotifyModal = true;
          this.adminNotifyTitle = 'Confirmation';
          this.adminNotifyBody = 'You are switching to the "'+payload.name+'" committee.';
        }else if('SWITCH_ROLE' === action) {
          this.updateUserAction(action, payload, true, false);
          this.showAdminNotifyModal = true;
          this.adminNotifyTitle = 'Confirmation';
          this.adminNotifyBody = 'You will now view the site as "'+getRoleName(payload)+'".';
        }
      },
      confirmAction() {
          this.userAction.isConfirmed = true;
          if('SWITCH_COMMITTEE' === this.userAction.actionKey) {
            this.switchCommittee(this.userAction.actionPayload);
          }else if('SWITCH_ROLE' === this.userAction.actionKey) {
            this.switchRole(this.userAction.actionPayload);
          }
          this.closeModal();
      },
      closeModal() {
        this.updateUserAction('', null, false, false);
        this.showAdminNotifyModal = false;
        this.adminNotifyTitle = null;
        this.adminNotifyBody = null;
      },
      updateUserAction(action, payload, requireConfirmation, isConfirmed) {
        this.userAction.actionKey = action;
        this.userAction.actionPayload = payload;
        this.userAction.requireConfirmation = requireConfirmation;
        this.userAction.isConfirmed = isConfirmed;
      },
      checkRoleFullName(role) {
        const matchingRole = constants.USER_ROLES.find(r => r.name === role);
        return matchingRole ? matchingRole.fullName : role;
      },
      checkCurrentRole(role) {
        return role === this.currentRole;
      },
      checkCurrentCommittee(com) {
        return com === this.$store.getters.getSelectedCommittee;
      },
      logout() {
         this.$store.dispatch(LOGOUT, this.credentials).then(data => {
           
         }).finally( () =>{
           router.push('/');
           location.reload();
         });
      },
      switchCommittee,
      switchRole
    },
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;
    background: $gradient;
    @include minpoint(tablet) {
      background: $stone;
      padding: 10px $page-gutter;
    }
    &__logo {
      width: 145px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
      @include minpoint(tablet) {
        display: none;
      }
    }
    &__trigger {
      position: relative;
      z-index: $z-menu-trigger;
      margin-right: auto;
      @include minpoint(tablet) {
        margin-right: 10px;
        display: none;
      }
    }
    &__title {
      display: none;
      color: $white;
      margin-right: 1rem;
      margin-bottom: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @include minpoint(tablet) {
        display: block;
      }
    }
    &__menus {
      display: flex;
      margin-left: auto;
      flex-shrink: 0;
    }
    &__dropdown {
      display: flex;
    }
    &__dropdown--menu {
      display: none;
      @include minpoint(tablet) {
        display: block;
        margin-left: 1rem;
      }
    }
    &__dropdown-list {
      padding-left: .25rem;
      padding-right: .25rem;
    }
    &__dropdown-item {
      display: block;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      cursor: pointer;
      &:last-child {
        padding-bottom: 0;
      }
      &,
      &:hover,
      &:focus {
        text-decoration: none;
      }
    }
  }
</style>
